import {Component, OnDestroy, OnInit} from '@angular/core';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Constant} from '../../../../global/util/Constant';
import {Page} from '../../../../global/util/enum/Page';
import {Workflow} from '../../../model/Workflow';
import {DocumentState} from '../../../../global/util/DocumentState';
import {DomSanitizer} from '@angular/platform-browser';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentService} from '../../../service/document.service';
import {SignService} from '../../../service/sign.service';
import {AuthService} from '../../../service/auth/auth.service';
import {ApplicationService} from '../../../service/application.service';
import {Router} from '@angular/router';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Dialog} from '../../../../global/util/Dialog';
import {InformType} from '../../../../global/util/enum/InformType';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {Document} from '../../../model/Document';
import {DocumentPreviewComponent} from '../document-preview/document-preview.component';
import {Partner} from '../../../model/Partner';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';
import {EnterpriseService} from '../../../service/enterprise.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {WorkflowService} from '../../../service/workflow.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-delete-document-permanentely',
  templateUrl: './delete-document-permanentely.component.html',
  styleUrls: ['./delete-document-permanentely.component.css']
})
export class DeleteDocumentPermanentelyComponent implements OnInit, OnDestroy {
  public documents: any[] = [];
  public page: any = {};
  public links: any = {};
  private documentUrl: string;
  public enumPage = Page;
  public loading: boolean;
  private entityName = 'TITLE.DOCUMENT';
  public title = 'TITLE.DELETED-DOCUMENTS';
  private selectedDocuments: any[] = [];
  public checkedShowAllOption = false;
  private interval: any;
  public calledOfAutorefresh = false;
  public loadingSave = false;
  public loadingShowBy = false;
  public loadingAttend = false;
  private personId;
  public enterprises: any[] = [];
  public enterpriseIdSelected: number;
  public enterpriseSelected: any;
  public workflows: Workflow[] = [];
  public workflowSelected: any;
  public workflowIdSelected: number;
  public term2Search: string;
  public officialTerm2Search: string;
  public partnerId: number;
  public partnerSelected: Partner;
  public partners: Partner[] = [];
  public partnerIdSelected: number;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(private sanitizer: DomSanitizer,
              private modalService: NgbModal,
              private documentService: DocumentService,
              private signService: SignService,
              private authenticationService: AuthService,
              private applicationService: ApplicationService,
              private enterpriseDataService: EnterpriseDataService,
              private workflowService: WorkflowService,
              private enterpriseService: EnterpriseService,
              private router: Router,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.setDefaultData();
  }

  ngOnInit(): void {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.beginAutorefreh();
  }

  ngOnDestroy(): void {
    this.destroyAutorefresh();
  }

  private beginAutorefreh() {
    this.interval = setInterval(() => {
      if (this.documents.length !== 0) {
        this.loadDocuments(Page.Self, 'auto');
      } else {
        this.loadDocuments(Page.First, 'auto');
      }
    }, 60000);
  }

  private setDefaultData() {
    this.partners = LocalStorage.getPartnersExtra();
    this.partnerSelected = this.partners[Constant.ZERO_INDEX];
    this.partnerIdSelected = this.partnerSelected.id;
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.workflows = LocalStorage.getDefaultWorkflows();
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.workflowSelected = this.workflows[Constant.ZERO_INDEX];
    this.getEnterprisesByPartner(this.partnerSelected.id);
    // this.enterprises = LocalStorage.getEnterprisesExtraBy(this.partnerSelected.id);
    // this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.personId = LocalStorage.getPersonId();
    this.workflows = LocalStorage.getWorkflowsExtraByPerson();
    this.partnerId = LocalStorage.getPartnerId();
    // this.enterpriseIdSelected = this.enterpriseSelected.id;
    this.workflowSelected = this.workflows[Constant.ZERO_INDEX];
    this.workflowIdSelected = this.workflowSelected.id;
  }

  public reloadEnterprises() {
    this.getEnterprisesByPartner(this.partnerSelected.id);
    // this.loadDocuments(Page.First);
  }

  public reloadWorkflows() {
    this.enterpriseIdSelected = this.enterpriseSelected.id;
    this.getAllWorkflowBy(this.enterpriseSelected.id).subscribe((next: Workflow[]) => {
      console.log(next);
      this.workflows = next;
      this.documents = [];
      if (Constant.EMPTY_LIST !== this.workflows.length) {
        this.workflowSelected = this.workflows[Constant.ZERO_INDEX];
        this.workflowIdSelected = this.workflowSelected.id;
        this.loadDocuments(Page.First);
      }
    });

  }

  public reloadDocuments() {
    this.officialTerm2Search = this.term2Search;
    this.documents = [];
    this.workflowIdSelected = this.workflowSelected.id;
    this.loadDocuments(Page.First);
  }

  public loadDocuments(page: Page, callAutorefresh?: string): void {
    this.calledOfAutorefresh = false;
    if (callAutorefresh) {
      this.calledOfAutorefresh = true;
    }
    if (this.officialTerm2Search === undefined) {
      this.officialTerm2Search = '';
    }
    switch (page) {
      case Page.First:
        this.documentUrl = Constant.ROOT_API_V1
          .concat('/partner/')
          .concat(String(this.partnerIdSelected))
          .concat('/enterprises/')
          .concat(String(this.enterpriseIdSelected))
          .concat('/workflows/')
          .concat(String(this.workflowIdSelected))
          .concat('/documents/deleted')
          .concat('?findby=')
          .concat(this.officialTerm2Search)
          .concat('&size=', this.pageNumber, '&sort=id,desc');
        break;
      case Page.Previous:
        this.documentUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.documentUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.documentUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.documentUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    if (this.authenticationService.isAuthenticated()) {
      this.getDocuments(this.documentUrl);
    }
  }


  private getDocuments(url: string) {
    this.loading = true;
    this.title = this.translate.instant('TITLE.DELETED-DOCUMENTS');
    this.documentService.get(url).subscribe((next: any) => {
      this.loadingShowBy = this.loading = false;
      if (next._embedded) {
        this.documents = next._embedded.documents;
      } else {
        this.documents = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.destroyAutorefresh();
      this.loading = false;
      this.processError(this.title, error);
    });
  }

  private destroyAutorefresh() {
    clearInterval(this.interval);
  }

  private processError(title: string, error: any) {
    const status = error.status;
    let message;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        title = this.translate.instant('TITLE.SESSION-EXPIRED');
        message = this.translate.instant('MESSAGE.SESSION-EXPIRED');
        Dialog.show(InformType.Info, title, message);
        this.logout();
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  public wasAllSelected(): boolean {
    if (this.selectedDocuments.length === 0) {
      return false;
    }
    return !(this.documents.find(document => !this.isAdded(document)) !== undefined);
  }

  public addOrRemoveAll(event) {
    if (event.target.checked) {
      this.documents.filter(document => !this.isAdded(document)).forEach(document => this.selectedDocuments.push(document));
    } else {
      this.documents.filter(document => this.isAdded(document)).forEach(document => this.selectedDocuments.splice(this.getIndexOf(document), 1));
    }
  }

  private isAdded(document: any): boolean {
    return this.selectedDocuments.find(value => value.id === document.id) !== undefined;
  }

  private getIndexOf(document: any): number {
    return this.selectedDocuments.findIndex(value => value.id === document.id);
  }

  public wasSelected(document: any): boolean {
    return this.isAdded(document);
  }

  public addOrRemove(event, document: any) {
    if (event.target.checked) {
      this.selectedDocuments.push(document);
    } else {
      const index = this.getIndexOf(document);
      this.selectedDocuments.splice(index, 1);
    }
  }

  public openModalDelete(document: any) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-DOCUMENT');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-DELETE-DOCUMENT');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.deleteDocumentPermanently(document);
      }
    });
  }

  private deleteDocumentPermanently(document: Document) {
    this.loadingSave = true;
    const documents: Document[] = [];
    documents.push(document);
    this.documentService.permanentlyDelete(documents).subscribe(() => {
      this.loadingSave = false;
      this.loadDocuments(Page.Self);
      Dialog.show(InformType.Success, this.translate.instant('TITLE.DOCUMENT'));
    }, error => {
      this.loadingSave = false;
      const title = this.translate.instant('TITLE.DELETE-DOCUMENT');
      this.processError(title, error);
    });
  }

  public search() {
    this.officialTerm2Search = this.term2Search;
    this.reloadDocuments();
  }

  public openModalDeleteBatch() {
    let listDocuments: any[] = [];
    listDocuments = this.selectedDocuments;
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-DOCUMENT');
    modalRef.componentInstance.body = this.buildBodyContent(listDocuments);
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.deleteSelected(listDocuments);
      }
    });
  }

  private buildBodyContent(listDocuments: any[]): string {
    const lengthList = listDocuments.length;
    if (lengthList === 1) {
      return this.translate.instant('QUESTION.ARE-YOU-SURE-PERMANENTLY-DELETE-DOCUMENT');
    } else {
      return this.translate.instant('QUESTION.ARE-YOU-SURE-PERMANENTLY-DELETE-DOCUMENTS').replace('%d', lengthList);
    }
  }

  private deleteSelected(listDocuments: any[]) {
    this.loadingAttend = true;
    this.documentService.permanentlyDelete(listDocuments).subscribe(() => {
      this.loadingAttend = false;
      this.selectedDocuments = [];
      this.checkedShowAllOption = false;
      this.loadDocuments(Page.Self);
      Dialog.show(InformType.Success, this.translate.instant('TITLE.DOCUMENTS'));
    }, error => {
      this.loadingAttend = false;
      this.processError(this.translate.instant('TITLE.DELETED-DOCUMENTS'), error);
    });
  }

  get isEmptySelectedList(): boolean {
    return this.selectedDocuments.length === 0;
  }

  public downloadOf(documentsource: any) {
    const url = documentsource._links.stream.href.replace('http', Constant.SCHEMA);
    const more = documentsource._more;
    this.documentService.download(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = more.basenameFile.concat(more.suffix === undefined ? '' : more.suffix, '.', more.extension);
      control.click();
    }, error => {
      const title = this.translate.instant('TITLE.DOWNLOAD-DOCUMENTS');
      this.processError(title, error);
    });
  }

  public wasDeleted(document: any): boolean {
    return DocumentState.PERMANENTLY_DELETED === document.stateId;
  }

  public openModalView(document: Document) {
    const documents: Document[] = [];
    documents.push(document);
    const modalSize = 'xl';
    this.openModalView2(documents, modalSize);
  }

  public openModalView2(documents: any[], modalSize: string) {
    const modalRef = this.modalService.open(DocumentPreviewComponent, {
      backdrop: 'static',
      size: modalSize
    });
    this.entityName = this.translate.instant('TITLE.DOCUMENTS');
    modalRef.componentInstance.documents = documents;
    modalRef.componentInstance.personId = this.personId;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadDocuments(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public hasDocuments(document: any): boolean {
    return document._more.resources.length > 0 && document._more.resources[0].url;
  }


  private getAllWorkflowBy(enterpriseId: number): Observable<Workflow[]> {
    return this.workflowService.getWorkflowsExtraBy(enterpriseId).pipe(
      map((workflows: Workflow[]) => {
        const workflowsFilter = workflows.filter(workflow =>
          workflow.enterpriseId === enterpriseId &&
          workflow.ready2Use === Constant.READY_TO_USE);
        return [{
          id: 0,
          description: 'TODOS',
        }, ...workflowsFilter];
      })
    );
  }

  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterprises = enterprises.sort();
      this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
      this.enterpriseIdSelected = this.enterpriseSelected.id;
      this.partnerIdSelected = this.partnerSelected.id;
      this.loadDocuments(Page.First);
    });
  }
}
